import { mark } from 'shared/user-timing';

const loadPusher = () => new Promise(resolve => {
	if (window.Pusher) {
		return resolve(window.Pusher);
	}
	
	mark('Loading pusher');
	
	import('pusher-js' /* webpackChunkName: "achunk~pusher-js" */)
		.then(({ default: Pusher }) => {
			mark('Loaded pusher');
			window.Pusher = Pusher;
			
			// if (__DEV__) {
			// 	Pusher.logToConsole = true;
			// }
			
			resolve(Pusher);
		});
});

export const loadEcho = () => new Promise(resolve => {
	if (window.Echo) {
		return resolve(window.Echo);
	}
	
	mark('Loading Echo');
	
	loadPusher()
		.then(() => import('laravel-echo' /* webpackChunkName: "achunk~laravel-echo" */))
		.then(({ default: Echo }) => {
			mark('Loaded Echo');
			window.Echo = new Echo({
				broadcaster: 'pusher',
				encrypted: true,
				...window.pusherConfig,
			});
			
			return resolve(window.Echo);
		});
});
